const defaultColor = { bg: '#488DCA', fg: '#FFFFFF', default: true };
const colorByIdSet = {
  'ASSET_CATEGORY_COLOR_EQTY': { bg: '#45C583', fg: '#32374C' },
  'ASSET_CATEGORY_COLOR_FIXD': { bg: '#60C0E0', fg: '#32374C' },
  'ASSET_CATEGORY_COLOR_CASH': { bg: '#E9B04C', fg: '#32374C' },
  'ASSET_CATEGORY_COLOR_FUND': { bg: '#8B62A9', fg: '#E8E8E8' },
  'ASSET_CATEGORY_COLOR_NA': { bg: '#A0A5AE', fg: '#E8E8E8' },
  "COLLATERAL_GRADE_COLOR_C1": { bg: '#498dca', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_C2": { bg: '#75a9d7', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_C3": { bg: '#9cc2e2', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_D1": { bg: '#4d4df5', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_D2": { bg: '#6e6ef7', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_D3": { bg: '#9f9ff9', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_K1": { bg: '#6e83e5', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_K2": { bg: '#93a3ec', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_K3": { bg: '#bec8f4', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_G1": { bg: '#60C0E0', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_G2": { bg: '#80CDE7', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_G3": { bg: '#A0DAED', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_E1": { bg: '#45C583', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_E2": { bg: '#6AD19C', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_E3": { bg: '#8fddb5', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_F1": { bg: '#8B62A9', fg: '#E8E8E8' },
  "COLLATERAL_GRADE_COLOR_F2": { bg: '#A281BA', fg: '#E8E8E8' },
  "COLLATERAL_GRADE_COLOR_F3": { bg: '#BAA1CC', fg: '#E8E8E8' },
  "COLLATERAL_GRADE_COLOR_CA": { bg: '#E9B04C', fg: '#32374C' },
  "COLLATERAL_GRADE_COLOR_NA": { bg: '#A0A5AE', fg: '#E8E8E8' },
  "COLLATERAL_GRADE_COLOR_UF": { bg: '#c97064', fg: '#E8E8E8' },

  'EXCLUSION_COLOR': { bg: '#AF3543', fg: '#AF3543' },

  'PERIOD_CURRENT_COLOR': { bg: '#72B767', fg: '#E8E8E8' },
  'PERIOD_PREVIOUS_COLOR': { bg: '#DE4A4E', fg: '#E8E8E8' },

  'EA_SHORT': { bg: '#E23333', bgDull: '#482834', bgCellDark: '#352734', bgCellLight: '#482834', fg: '#E8E8E8'},
  'EA_SHORT_FLOW': { bg: '#E23333', bgDull: '#482834', bgCellDark: '#352734', bgCellLight: '#482834', fg: '#E8E8E8' },
  'EA_SHORT_BLOCK': { bg: '#596079', bgDull: '#3E4356' },
  'EA_RQV': { bg: '#596079', bgDull: '#3E4356', bgCellDark: '#293A52', bgCellLight: '#2D4461', fg: '#E8E8E8', border: "#FDCE02", borderDull: "#BE0D0D" },
  'EA_COVERED': { bg: '#596079', bgDull: '#3E4356', border: "#0D7FBE", borderDull: "#0D7FBE", borderDashed: 5 },
  'EA_COVERED_FLOW': { bg: '#488DCA', bgDull: '#2D4461', bgCellDark: '#293A52', bgCellLight: '#2D4461', fg: '#E8E8E8' },
  'EA_COVERED_BLOCK': { bg: '#596079', bgDull: '#3E4356', border: "#0D7FBE", borderDull: "#0D7FBE", borderDashed: 5 },
  'EA_UNENCUMBERED': { bg: '#596079', bgDull: '#3E4356', border: '#FDCE02', borderDull: '#45C583' },
  'EA_ENCUMBERED': { bg: '#596079', bgDull: '#3E4356', border: '#FDCE02', borderDull: '#0D7FBE' },
  'EA_BASKET': { bg: '#596079', bgDull: '#3E4356', border: '#FDCE02', borderDull: '#FDCE02' },
  'TRADE_INCREASE_COLOR_BLOCK': { bg: '#596079', bgDull: '#3E4356', border: '#FFE500', borderDull: '#FFE500', borderDashed: 5 },
  'TRADE_DEALLOCATE_COLOR_BLOCK': { bg: '#596079', bgDull: '#3E4356', border: '#DD5AD0', borderDull: '#DD5AD0', borderDashed: 5 },
  'EA_DEALLOCATED': { bg: '#596079', bgDull: '#3E4356', border: '#DD5AD0', borderDull: '#DD5AD0', borderDashed: 5 },
  'TRADE_INCREASE_COLOR_FLOW': {
    bg: 'url(#TRADE_INC_FLOW)', gradient: [
      { color: '#E23333', offset: 0.6 },
      { color: '#FFE500', offset: 1 },
    ]
  },
  'TRADE_INCREASE_COVERED_COLOR_FLOW': {
    bg: 'url(#TRADE_INC_FLOW_COVERED)', gradient: [
      { color: '#0D7FBE', offset: 0.6 },
      { color: '#FFE500', offset: 1 },
    ]
  },
  'TRADE_DEALLOCATE_COLOR_FLOW': {
    bg: 'url(#TRADE_DEALLOC_FLOW)', gradient: [
      { color: '#E23333', offset: 0.6 },
      { color: '#DD5AD0', offset: 1 },
    ]
  },
  'TRADE_DEALLOCATE_COVERED_COLOR_FLOW': {
    bg: 'url(#TRADE_DEALLOC_FLOW_COVERED)', gradient: [
      { color: '#0D7FBE', offset: 0.6 },
      { color: '#DD5AD0', offset: 1 },
    ]
  },
};

function getColorById(id) {
  return colorByIdSet[id] || venueSummaryColorSets[id] || defaultColor;
}

const defaultVenueSummaryColor = { bg: '#488DCA', fg: '#FFFFFF' };
const venueSummaryColorSets = {
  'VENUE_SUMMARY_COLOR1': { bg: '#0D7FBE', fg: '#FFFFFF' },
  'VENUE_SUMMARY_COLOR2': { bg: '#488DCA', fg: '#32374C' },
  'VENUE_SUMMARY_COLOR3': { bg: '#45C583', fg: '#32374C' },
  'VENUE_SUMMARY_COLOR4': { bg: '#629536', fg: '#32374C' },
  'VENUE_SUMMARY_COLOR5': { bg: '#3C66AC', fg: '#E8E8E8' },
  'VENUE_SUMMARY_COLOR6': { bg: '#A0A5AE', fg: '#E8E8E8' },
  'VENUE_SUMMARY_COLOR7': { bg: '#E23333', fg: '#E8E8E8' },
  'VENUE_SUMMARY_COLOR8': { bg: '#D0AB1B', fg: '#E8E8E8' },
  'VENUE_SUMMARY_COLOR9': { bg: '#D0AB1B', fg: '#E8E8E8' },
  'VENUE_SUMMARY_COLOR10': { bg: '#488DCA', fg: '#E8E8E8' },
  'VENUE_SUMMARY_COLOR11': { bg: '#D0AB1B', fg: '#E8E8E8' },
  'VENUE_SUMMARY_COLOR12': { bg: '#E23333', fg: '#E8E8E8' },
  'VENUE_SUMMARY_COLOR13': { bg: '#5D5F6B', fg: '#E8E8E8' },
  'VENUE_SUMMARY_COLOR14': { bg: '#97B181', fg: '#E8E8E8' },
};

function getVenueSummaryColorById(id) {
  return venueSummaryColorSets[id] || defaultVenueSummaryColor;
}

const defaultBreakTypeColor = { bg: '#488dca', fg: '#FFFFFF' };
const breakTypeColorSets = {
};

function getBreakTypeColorById(id) {
  return breakTypeColorSets[id] || defaultBreakTypeColor;
}

const donutColorSets = {
  'DONUT_REMAINING_COLOR': '#DB2742',
  'DONUT_FILL_COLOR': '#4E5264'
};

function getDonutColorById(id) {
  return donutColorSets[id];
}

// The following is a modified version of code found by Sergio Pedercini, copyright maintained as below.
// Copyright (c) 2021 by Sergio Pedercini (https://codepen.io/sergiopedercini/pen/RLJYLj)
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to
// whom the Software is furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
// WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
const generateHSLFromString = (str) => {
  try {
    const hue = str.split('').map((char, i) => str.charCodeAt(i)).reduce((a, b) => a + ((b << 5) - b), 0) % 360;
    const saturation = 55;
    const lightness = 60;
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  } catch {
    // Fallback to pirum green
    return `hsl(112, 36%, 56%)`;
  }
};

export {
  getColorById,
  defaultColor,
  colorByIdSet,

  getVenueSummaryColorById,
  defaultVenueSummaryColor,
  venueSummaryColorSets,

  getBreakTypeColorById,

  donutColorSets,
  getDonutColorById,

  generateHSLFromString,
};
